import React, { useState, useRef, useEffect, FC } from 'react';
import L from 'leaflet';
import { TileLayer, FeatureGroup, Polygon, Marker, MapContainer, Popup } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';
import { POLYGON_COLORS } from 'utils/constants';
import { LatLngLiteral, LatLngTuple } from 'leaflet';
import { CoKitchenPolygons, CoKitchenType } from 'utils/types';
import './styles.scss';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

// show marker on map
const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

type ActionType = 'create' | 'edit' | 'none';
type MapProps = {
  cokitchen?: CoKitchenType;
  setCords?: (cords: LatLngLiteral[]) => void;
  positions?: LatLngLiteral[] | LatLngTuple[];
  type?: ActionType;
  onPolygonClick?: (polygon: CoKitchenPolygons) => void;
  withMarker?: boolean;
  hideButtons?: boolean;
};

const Map: FC<MapProps> = ({
  hideButtons = false,
  withMarker,
  cokitchen,
  setCords,
  type = 'none',
  positions,
  onPolygonClick
}) => {
  const {
    lat = '6.461928747152594',
    lng = '3.557585092620834',
    cokitchen_polygons
  } = cokitchen || {};
  const [center, setCenter] = useState({ lat: Number(lat), lng: Number(lng) });

  const mapRef = useRef(null);

  const _created = (e: any) => {
    setCords?.(e.layer._latlngs);
  };

  const _edited = (e: any) => {
    const layers = e?.layers?._layers;
    if (Object.keys(layers).length === 1)
      Object.values(layers).map((item: any) => {
        setCords?.(item?._latlngs[0]);
      });
  };

  const zoom_level = type === 'none' ? 12 : 10;

  useEffect(() => {
    setCenter({ lat: Number(lat), lng: Number(lng) });
  }, []);

  return (
    <div className='map'>
      <MapContainer center={center} zoom={zoom_level} ref={mapRef}>
        {!hideButtons && (
          <FeatureGroup>
            <EditControl
              position='topright'
              onCreated={_created}
              draw={{
                rectangle: false,
                circle: false,
                circlemarker: false,
                marker: false,
                polyline: true,
                polygon: false
              }}
              onEdited={_edited}
            />
            {type === 'none' ? (
              cokitchen_polygons?.map((item, i) => {
                return (
                  <Polygon
                    eventHandlers={{
                      click: () => {
                        onPolygonClick?.(item);
                      }
                    }}
                    positions={item?.polygon as LatLngTuple[]}
                    key={i + 'map'}
                    pathOptions={{
                      color: POLYGON_COLORS[i]?.color_code,
                      fillColor: POLYGON_COLORS[i]?.color_code,
                      fillOpacity: 0.4,
                      dashArray: [5, 5],
                      weight: 2
                    }}
                  />
                );
              })
            ) : (
              <Polygon positions={positions || []} />
            )}
          </FeatureGroup>
        )}
        <TileLayer url='https://api.maptiler.com/maps/basic/256/{z}/{x}/{y}.png?key=aPhWpltxUiQ7PEPLnk6Q' />
        {withMarker && (
          <Marker position={center}>
            <Popup>
              <span className='text-xs font-manrope text-gray-5'>{cokitchen?.name}</span>
            </Popup>
          </Marker>
        )}
        )
      </MapContainer>
    </div>
  );
};

export default Map;
